import { render } from "./RevenueGrowthChart.vue?vue&type=template&id=fb9c60e8&ts=true"
import script from "./RevenueGrowthChart.vue?vue&type=script&lang=ts"
export * from "./RevenueGrowthChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__